import React from 'react';

var LibrarySelector = React.createClass({
    getInitialState: function(){
      return { theme: false, 
               layout: false,
               codeSnippet: false,
               allPack: false,
               shared: false,
               purchases: false,
               archivePack: false,
               pendingTransfer: false }
    },

    componentWillReceiveProps: function(){
      switch (this.props.library){
        case "Themes": this.setState({theme : true, codeSnippet: false, layout: false, allPack: false, shared: false, "purchases": false, "archivePack": false, "pendingTransfer": false });  break;
        case "Layouts": this.setState({theme : false, codeSnippet: false, layout: true, allPack: false, shared: false, "purchases": false, "archivePack": false, "pendingTransfer": false });  break;
        case "Code Snippets" : this.setState({theme : false, codeSnippet: true, layout: false , allPack: false, shared: false, "purchases": false, "archivePack": false, "pendingTransfer": false });  break;
        case "All Packages": this.setState({theme : false, codeSnippet: false, layout: false, allPack: true, shared: false, "purchases": false, "archivePack": false, "pendingTransfer": false }); break;
        case "Shared with me": this.setState({theme : false, codeSnippet: false, layout: false, allPack: false, shared: true, "purchases": false, "archivePack": false, "pendingTransfer": false });  break;
        case "My Purchases": this.setState({theme : false, codeSnippet: false, layout: false, allPack: false, shared: false, "purchases": true, "archivePack": false, "pendingTransfer": false });  break;
        case "Archived Packages" : this.setState({theme : false, codeSnippet: false, layout: false, allPack: false, shared: false, "purchases": false, "archivePack": true, "pendingTransfer": false });  break;
        case "Pending Transfers" : this.setState({theme : false, codeSnippet: false, layout: false, allPack: false, shared: false, "purchases": false, "archivePack": false, "pendingTransfer": true });  break;
      }
    },

    handleDropdownClick: function(e){
        e.stopPropagation();
        this.props.libSelectShow();
    },

    handleClick: function(value){
        this.props.onLibrarySelect(value); // this will set the library name property in Application
    },

    render: function(){
        return(
              <div className="content__col content__col--second">
                  <div className="custom-dropdown custom-dropdown--blue main__nav">
                      <dl className="dropdown">
                        <dt onClick = {this.handleDropdownClick}>
                          <a href="javascript:void(0)">
                            <span className="value">{this.props.library}</span>
                          </a>
                        </dt>
                        <dd>
                          { this.props.libSelect ?
                            <div> 
                              <ul>
                                <li  onClick = {this.handleClick.bind(this,"Themes")}>
                                  <a href="javascript:void(0)" className = {this.state.theme ? "selected_option" : ""}>
                                    <span className="value">Themes</span>
                                  </a>
                                </li>
                                <li  onClick = {this.handleClick.bind(this,"Layouts")}>
                                  <a href="javascript:void(0)" className = {this.state.layout ? "selected_option" : ""}> 
                                    <span className="value">Layouts</span>
                                  </a>
                                </li>
                                <li onClick = {this.handleClick.bind(this,"Code Snippets")}>
                                  <a href="javascript:void(0)" className = {this.state.codeSnippet ? "selected_option" : ""}>
                                    <span className="value">Code Snippets</span>
                                  </a>
                                </li>
                               <li  onClick = {this.handleClick.bind(this,"All Packages")}>
                                  <a href="javascript:void(0)" className = {this.state.allPack ? "selected_option" : ""}>
                                    <span className="value">All Packages</span>
                                  </a>
                                </li>
                                 <li  onClick = {this.handleClick.bind(this,"Shared with me")}>
                                  <a href="javascript:void(0)" className = {this.state.shared ? "selected_option" : ""}>
                                    <span className="value">Shared with me</span>
                                  </a>
                                </li>
                                <li  onClick = {this.handleClick.bind(this,"Pending Transfers")}>
                                  <a href="javascript:void(0)" className = {this.state.pendingTransfer ? "selected_option" : ""}>
                                    <span className="value">Pending Transfers</span>
                                  </a>
                                </li>
                                <li  onClick = {this.handleClick.bind(this,"My Purchases")}>
                                  <a href="javascript:void(0)" className = {this.state.purchases ? "selected_option" : ""}>
                                    <span className="value">My Purchases</span>
                                  </a>
                                </li>
                                <li  onClick = {this.handleClick.bind(this,"Archived Packages")}>
                                  <a href="javascript:void(0)" className = {this.state.archivePack ? "selected_option" : ""}>
                                    <span className="value">Archived Packages</span>
                                  </a>
                                </li>
                              </ul> 
                            </div> : <div /> 
                          }
                        </dd>
                      </dl>
                  </div>
              </div>
        );
    }
});

export {LibrarySelector}


/** WEBPACK FOOTER **
 ** ./html/components/LibrarySelector.jsx
 **/